import React from 'react';
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import useAuth from "../../system/APIAuth";
import { IconButton, ListItemIcon, Menu, MenuItem, Box, Tooltip } from '@mui/material';
import { Article, Help, HelpCenter, School } from '@mui/icons-material';
import { useStarscapeAcademy } from 'hooks/useStarscapeAcademy';

export default function HelpMenu() {
	const auth = useAuth();
	const { i18n } = useTranslation();
  const { openAcademy, errorMessage, isLoading } = useStarscapeAcademy();

	const [helpMenuAnchorEl, setHelpMenuAnchorEl] = React.useState<null | HTMLElement>(null);

	const handleHelpClick = (event: React.MouseEvent<HTMLElement>) => {
		setHelpMenuAnchorEl(event.currentTarget);
	};

	return (
		<Box sx={{ display: "inline-block", verticalAlign: "middle" }}>
      {auth.user && 
        <>
          <IconButton
            onClick={handleHelpClick}
            sx={{
              fontSize: "1.7rem",
              color: "text.disabled",
              "&:hover": { color: "primary.main" },
            }}>
            <Help fontSize="inherit" />
          </IconButton>
          <Menu anchorEl={helpMenuAnchorEl} open={Boolean(helpMenuAnchorEl)} onClose={() => setHelpMenuAnchorEl(null)}>
            {/* Help Center */}
            <Link to="https://help.infegy.com/en/" target="_blank" rel="noopener" style={{ textDecoration: "inherit", color: "inherit" }}>
              <MenuItem onClick={() => setHelpMenuAnchorEl(null)}>
                <ListItemIcon>
                  <HelpCenter fontSize="small" />
                </ListItemIcon>
                {i18n.t("nav.help")}
              </MenuItem>
            </Link>

            {/* API Documentation */}
            {auth.user?.role !== 'ai-studio' && (
              <Link to="https://starscape.infegy.com/api/docs/" target="_blank" rel="noopener" style={{ textDecoration: "inherit", color: "inherit" }}>
                <MenuItem onClick={() => setHelpMenuAnchorEl(null)}>
                  <ListItemIcon>
                    <Article fontSize="small" />
                  </ListItemIcon>
                  {i18n.t("nav.api")}
                </MenuItem>
              </Link>
            )}

            {/* Starscape Academy */}
            <Tooltip title={errorMessage || ""} placement="left">
              <Box>
                <MenuItem
                  onClick={async () => {
                    const didOpen = await openAcademy();
                    if (didOpen) {
                      setHelpMenuAnchorEl(null);
                    }
                  }}
                  disabled={isLoading}
                  sx={{ opacity: isLoading ? 0.5 : 1 }}>
                  <ListItemIcon>
                    <School fontSize="small" />
                  </ListItemIcon>
                  {i18n.t("nav.academy")}
                </MenuItem>
              </Box>
            </Tooltip>
          </Menu>
        </>
      }
		</Box>
	);
}
